import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import {
  selectPrefix,
  selectWidth,
  selectreportFromDate,
  selectreportToDate,
  setreportsFromDate,
  setreportsTodate,
} from "../../utility/Redux/profile";
import { FromToDate } from "../../utility/component/fromToDate";
import { GetPurchaseSummary } from "./func";
import { selectToken } from "../../utility/Redux/security";
import AccountMasterHelp from "../../help/listAccountMasterHelp";
import { PurchaseSummaryColumns } from "./columns";
import Footer from "./footer";
import { useReactToPrint } from "react-to-print";
import GeniusTableReports from "../../utility/component/geniusComponents/geniusTableData";
import PrintWithFooter from "../../utility/component/datagrid/printReportWithFooter";
import { PrintPurchaseSummaryColumns } from "./printColumns";
import IsLocalData from "../../utility/component/isLocalData";
import FromToDateMobile from "../../utility/component/fromToDateMobile";
import NewPrintReport from "../../utility/component/datagrid/newPrintReport";

const CreditNoteReport = () => {
  const prefix = useSelector(selectPrefix);
  const [purchaseList, setPurchaseList] = useState([]);
  const fromDate = useSelector(selectreportFromDate);
  const ToDate = useSelector(selectreportToDate);
  const width = useSelector(selectWidth);
  const [getCustomerData, setCustomerData] = useState({
    table_prefix: prefix,
    FDATE: moment(fromDate).format("YYYY-MM-DD"),
    TDATE: moment(ToDate).format("YYYY-MM-DD"),
    NAME: "",
    MOBILE: "",
    ACCOUNT_NO: "",
  });
  const columns = PurchaseSummaryColumns(width);
  const printColumns = PrintPurchaseSummaryColumns(width);
  const [customerHelpStatus, setCustomerHelpStatus] = useState(false);
  const [partyHelpStatus, setPartyHelpStatus] = useState(false);
  const printRef = useRef(null);
  const dispatch = useDispatch();
  const token = useSelector(selectToken);
  const okButton = () => {
    GetPurchaseSummary(
      {
        ...getCustomerData,
        FDATE: moment(fromDate).format("YYYY-MM-DD"),
        TDATE: moment(ToDate).format("YYYY-MM-DD"),
      },
      token,
      dispatch,
      setPurchaseList
    );
  };
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });

  useEffect(() => {
    const callback = (details, data) => {
      setCustomerData(details[0]);
      setPurchaseList(data);
      dispatch(setreportsFromDate(details[0].FDATE));
      dispatch(setreportsTodate(details[0].TDATE));
    };
    const elseFunc = () => {
      console.log("nothing");
    };
    IsLocalData("credit_note_report", callback, elseFunc);
  }, []);

  return (
    <div className=" bg-white flex flex-col h-full w-full overflow-y-scroll">
      <div className=" flex flex-col h-full p-3  w-full">
        <div>
          {window.innerWidth <= 1000 ? (
            <>
              <FromToDateMobile
                partyData={{
                  NAME: getCustomerData.NAME,
                  MOBILE: getCustomerData.MOBILE,
                }}
                onPrintClick={handlePrint}
                onPartyMasterSearchClick={(e) => setPartyHelpStatus(true)}
                submit={okButton}
                partyClear={() => {
                  setCustomerData((e) => {
                    return {
                      ...e,
                      table_prefix: prefix,
                      FDATE: moment(fromDate).format("YYYY-MM-DD"),
                      TDATE: moment(ToDate).format("YYYY-MM-DD"),
                      NAME: "",
                      MOBILE: "",
                      ACCOUNT_NO: "",
                    };
                  });
                  setPurchaseList([]);
                }}
              />
            </>
          ) : (
            <FromToDate
              onPrintClick={handlePrint}
              partyData={{
                NAME: getCustomerData.NAME,
                MOBILE: getCustomerData.MOBILE,
              }}
              hideReset
              onPartyMasterSearchClick={(e) => setPartyHelpStatus(true)}
              submit={okButton}
              partyClear={() => {
                setCustomerData((e) => {
                  return {
                    ...e,
                    table_prefix: prefix,
                    FDATE: moment(fromDate).format("YYYY-MM-DD"),
                    TDATE: moment(ToDate).format("YYYY-MM-DD"),
                    NAME: "",
                    MOBILE: "",
                    ACCOUNT_NO: "",
                  };
                });
                setPurchaseList([]);
              }}
            />
          )}
        </div>

        <div
          style={{ height: `calc(100% - 0px)`, width: "100%", marginTop: 6 }}
          className=" mb-2 "
        >
          {purchaseList[0] ? (
            <GeniusTableReports columns={columns} data={purchaseList} />
          ) : (
            <div className="h-full flex justify-center items-center text-sm text-gray-400 border mt-3 rounded-sm">
              No Records Found
            </div>
          )}
        </div>

        <div>
          <div
            style={{
              display: "none",
            }}
          >
            <div ref={printRef}>
              <NewPrintReport
                title={"Credit Note Report"}
                data={purchaseList}
                details={[
                  {
                    name: "Party Name",
                    value: getCustomerData.NAME,
                  },
                  {
                    name: "From Date",
                    value: moment(fromDate).format("DD/MM/YYYY"),
                  },
                  {
                    name: "To Date",
                    value: moment(ToDate).format("DD/MM/YYYY"),
                  },
                ]}
                columns={columns}
                footer={
                  <Footer
                    isFeilds={
                      <div className="flex justify-end text-sm mt-2">
                        <div>
                          <div className="flex ">
                            <div className="font-semibold w-[160px] text-right ">
                              Total Grant Total :
                            </div>
                            <div className="ml-2 flex flex-1 justify-end ">
                              {purchaseList.reduce(
                                (acc, row) => acc + Number(row.GTOTAL),
                                0
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                    columns={columns}
                    rows={purchaseList}
                  />
                }
              />
            </div>
          </div>
        </div>
      </div>
      <AccountMasterHelp
        onRowClick={(e) => {
          console.log(e);
          setCustomerData((c) => {
            return {
              ...c,
              NAME: e.row.NAME,
              MOBILE: e.row.MOBILE,
              ACCOUNT_NO: e.row.ACCOUNT_NO,
            };
          });
          setPartyHelpStatus(false);
        }}
        status={partyHelpStatus}
        onClose={() => {
          setPartyHelpStatus(false);
        }}
      />
    </div>
  );
};

export default CreditNoteReport;
